module.exports = __webpack_public_path__ + "img/mind_template_item_2_5.917e4371.png";